import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Components, fireLogEvent, sendRioEvent, SpecType, updateRioClient } from '@chegg/commerce-utils';
import { useEffect } from 'react';
import { RESUBSCRIBE_REVIEW } from '../views/CartCheckout/constants';
import { sendComponentLoadedEvent } from '../views/CartCheckout/helpers';
// Send Rio event upon initialization
/* istanbul ignore next */
export var useCartCheckoutRioEvents = function useCartCheckoutRioEvents(_ref) {
  var action = _ref.action,
    currencyCode = _ref.currencyCode,
    externalId = _ref.externalId,
    isReviewStep = _ref.isReviewStep,
    isRioInitialized = _ref.isRioInitialized,
    namespace = _ref.namespace,
    priceWithoutCurrency = _ref.priceWithoutCurrency,
    selectedProductVariationPrice = _ref.selectedProductVariationPrice,
    reviewStepEnabled = _ref.reviewStepEnabled,
    rioConfig = _ref.rioConfig,
    sendRioViewEvents = _ref.sendRioViewEvents;
  var selectedProductVariationPriceWithoutCurrency = !!selectedProductVariationPrice ? Number(selectedProductVariationPrice.replace('$', '')) : undefined;
  var initEffect = function initEffect() {
    isRioInitialized && sendComponentLoadedEvent({
      action: action,
      namespace: namespace,
      externalId: externalId,
      productData: {
        product_id: externalId,
        display_price: selectedProductVariationPriceWithoutCurrency !== null && selectedProductVariationPriceWithoutCurrency !== void 0 ? selectedProductVariationPriceWithoutCurrency : priceWithoutCurrency,
        product_type: null,
        quantity: 1,
        currency_code: currencyCode
      },
      sendRioViewEvents: sendRioViewEvents
    });
  };
  var reviewStepEffect = function reviewStepEffect() {
    var reviewStepRioConfig = rioConfig && _objectSpread({}, rioConfig);
    if (reviewStepRioConfig && isReviewStep) {
      reviewStepRioConfig.view.view_name = RESUBSCRIBE_REVIEW;
    }
    if (rioConfig && sendRioViewEvents && reviewStepEnabled) {
      updateRioClient(isReviewStep ? reviewStepRioConfig : rioConfig, namespace);
      isReviewStep && sendRioEvent({
        info: Components.REVIEW_STEP,
        specType: SpecType.PAGE_VIEW,
        callback: fireLogEvent,
        namespace: namespace,
        force: false
      });
    }
  };
  useEffect(initEffect, [isRioInitialized]);
  useEffect(reviewStepEffect, [isReviewStep]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/hooks/useCartCheckoutRioEvents.js
// module id = 4352
// module chunks = 11